import React, { useEffect, useState } from "react";
import {
    Box,
    CircularProgress,
    Popover,
    Typography
} from "@mui/material";

import { listarHistoricoOS } from "./integracaoApi";
import { formatarDataHora, rotuloAcaoHistorico } from "./utils";

const PopoverHistoricoOS = ({ anchorEl, osId, onClose }) => {
    const [registros, setRegistros] = useState([]);
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState("");

    const aberto = Boolean(anchorEl) && Boolean(osId);

    useEffect(() => {
        if (!aberto) return;

        let ativo = true;
        setLoading(true);
        setErro("");
        listarHistoricoOS(osId)
            .then((itens) => ativo && setRegistros(itens))
            .catch(() => ativo && setErro("Erro ao carregar o histórico."))
            .finally(() => ativo && setLoading(false));

        return () => { ativo = false; };
    }, [aberto, osId]);

    return (
        <Popover
            open={aberto}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
            <Box sx={{ p: 2, minWidth: "18rem" }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#132350" }}>
                    📋 Histórico da OS #{osId}
                </Typography>

                {loading && (
                    <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                        <CircularProgress size={20} />
                    </Box>
                )}

                {!loading && erro && (
                    <Typography variant="caption" color="error">{erro}</Typography>
                )}

                {!loading && !erro && registros.length === 0 && (
                    <Typography variant="caption" color="text.secondary">
                        Nenhum registro encontrado.
                    </Typography>
                )}

                {!loading && !erro && registros.map((registro, indice) => (
                    <Box key={indice} sx={{ display: "flex", gap: 2, py: 0.5, borderTop: indice > 0 ? "1px solid #F0F2F7" : "none" }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: "6.5rem" }}>
                            {rotuloAcaoHistorico(registro.acao)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {formatarDataHora(registro.data)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {registro.usuario || "—"}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Popover>
    );
};

export default React.memo(PopoverHistoricoOS);
